
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.835 2.965c-.801-.777-1.794-1.165-2.812-1.165a3.962 3.962 0 00-2.811 1.165l-1.22 1.22a4.86 4.86 0 011.179.844c.088.088.166.183.246.276l1.067-1.067a2.119 2.119 0 011.539-.638c.581 0 1.128.226 1.539.637.41.411.637.958.637 1.54 0 .58-.226 1.127-.637 1.538l-3.75 3.749c-.407.386-.956.636-1.535.636-.58 0-1.128-.226-1.539-.637a2.18 2.18 0 01-.663-1.54c0-.582.226-1.128.637-1.539l.125-.098c-.06-.11-.121-.222-.211-.312a1.263 1.263 0 00-.903-.374c-.336 0-.65.131-.889.365-.864 1.517-.665 3.476.63 4.77a3.965 3.965 0 002.813 1.165 3.963 3.963 0 002.811-1.165l3.747-3.748c.8-.8 1.188-1.857 1.164-2.906a3.917 3.917 0 00-1.164-2.716zm-10.254 9.73l-1.066 1.066c-.41.389-.959.639-1.538.639a2.161 2.161 0 01-1.539-.637 2.162 2.162 0 01-.637-1.54c0-.58.226-1.127.637-1.538l3.75-3.749A2.11 2.11 0 017.722 6.3c.605 0 1.128.226 1.539.637.41.411.637.958.637 1.539s-.226 1.128-.637 1.539l-.099.099c.059.11.119.222.21.313a1.276 1.276 0 001.793.008c.863-1.517.664-3.476-.63-4.77C9.734 4.888 8.741 4.5 7.723 4.5a3.959 3.959 0 00-2.81 1.164l-3.748 3.75A3.964 3.964 0 000 12.223c0 1.018.388 2.036 1.165 2.812A3.967 3.967 0 003.977 16.2a3.963 3.963 0 002.811-1.165l1.22-1.22a4.86 4.86 0 01-1.18-.844c-.09-.087-.165-.183-.247-.275z"}})])
          )
        }
      }
    